module.exports = __webpack_public_path__ + "img/1.442847ed.jpg";